import xhr from '../utils/xhr';
import { isNumber } from 'lodash';
import { ENTITIES_DEFAULT_SORT } from './../constants';

//TODO: Entities api needs some cleaning n'makeup
let api = {
    get: (oldFilters, sorting, pagination) => {
        // Fixing api incompatibility issue, will have to be consistent
        let filters = Object.assign({}, oldFilters);
        if (filters.query) filters.name = filters.query;
        if (isNumber(pagination.pageNumber)) pagination.page = pagination.pageNumber;

        const activeFilter = filters.active ? filters.active : "all";
        const categoryIdFilter = filters.categoryIdFilter && filters.categoryIdFilter !== "defaultAllCategories" ? "&categoryIdFilter=" + filters.categoryIdFilter : "";

        let nameFilter = filters.name && filters.name.length ? `&searchFilter=${encodeURIComponent(filters.name)}` : ""
        return xhr.get({
            url: `/api/entities/${activeFilter}?pageNumber=${pagination.page}&pageSize=${pagination.pageSize}&sortBy=${sorting.sortBy}&direction=${sorting.direction}${nameFilter}${categoryIdFilter}`
        });
    },
    count: (oldFilters, sorting = null) => {
        // Fixing api incompatibility issue, will have to be consistent
        let filters = Object.assign({}, oldFilters);
        if (filters.query) filters.name = filters.query;
        if (!sorting) {
            sorting = ENTITIES_DEFAULT_SORT;
        }
        const activeFilter = filters.active && filters.active !== "all" ? filters.active + "/" : "";
        const categoryIdFilter = filters.categoryIdFilter && filters.categoryIdFilter !== "defaultAllCategories" ? "&categoryIdFilter=" + filters.categoryIdFilter : "";

        let nameFilter = filters.name && filters.name.length ? `&searchFilter=${encodeURIComponent(filters.name)}` : ""
        return xhr.get({
            url: `/api/entities/companies/${activeFilter}count?sortBy=${sorting.sortBy}&direction=${sorting.direction}${nameFilter}${categoryIdFilter}`
        });
    },
    getSingle(companyId) {
        return api.specific([companyId]).then(companies => ({ body: companies }));
    },
    specific: (companyIds) => {
        return xhr.post({
            url: '/api/entities/specific-companies',
            data: companyIds
        }).then(response => response.body);
    },
    specificNames: (companyIds) => {
        return xhr.post({
            url: '/api/entities/specific-companies',
            data: companyIds
        }).then((response) => {
            let entities = {};
            for (let i = 0; i < response.body.length; i++) {
                entities[response.body[i].id] = response.body[i].companyTitle;
            }
            return entities;
        });
    },
    unassignCategoryFromEntity(entityId, categoryId) {
        return xhr.put({
            url: `/api/actions/remove-category/${categoryId}/${entityId}`
        })
    },
    assignCategoryToEntity(categoryId, entitiesId) {
        return xhr.put({
            url:  '/api/actions/assign-category/' + categoryId,
            data: entitiesId
        })
    },
    deleteEntities(entityIds) {
        return xhr.delete({
            url:  '/api/entities/companies/',
            data: entityIds
        })
    },
    activateEntities(entityIds) {
        return xhr.post({
            url:  '/api/entities/companies/activate/',
            data: entityIds
        })
    }
}

export default api;


// WEBPACK FOOTER //
// ./src/scripts/api/Entities.api.js